import React from "react";
import { useCursor } from "../../provider";

interface CursorProps {
  type: "grow" | "follow" | "custom";
  offset?: { x?: number; y?: number };
  children?: React.ReactNode;
}

function Cursor({ type, offset = { x: 0, y: 0 }, children }: CursorProps) {
  const { setCursorType, setCursorComponent, setHoverTarget } = useCursor();
  const ref = React.useRef<HTMLSpanElement>(null);

  const handleEnter = React.useCallback(() => {
    if (ref.current?.parentElement) {
      setHoverTarget(ref.current?.parentElement);
    }

    setCursorType(type);

    if ((type === "custom" || type === "follow") && children) {
      setCursorComponent(children, offset);
    }
  }, [
    type,
    children,
    offset,
    setHoverTarget,
    setCursorType,
    setCursorComponent,
  ]);

  React.useEffect(() => {
    const parentElement = ref.current?.parentElement;

    if (!parentElement) {
      return;
    }

    parentElement.addEventListener("mouseenter", handleEnter);

    return () => {
      parentElement.removeEventListener("mouseenter", handleEnter);
    };
  }, [handleEnter]);

  return (
    <span
      ref={ref}
      id="cursor-boundary"
      aria-hidden={true}
      style={{ display: "none" }}
    />
  );
}

export default React.memo(Cursor);
